import React from 'react';
import style from './Pagination.module.css';

// Paginación reutilizable para todas las secciones del catálogo.
const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (!totalPages || totalPages <= 1) return null;

  const goTo = (page) => {
    if (page < 1 || page > totalPages) return;
    onPageChange(page);
  };

  return (
    <div className={style.pagination}>
      <button
        className={style.arrowButton}
        onClick={() => goTo(currentPage - 3)}
        disabled={currentPage <= 3}
      >
        ⫷
      </button>
      <button
        className={style.arrowButton}
        onClick={() => goTo(currentPage - 1)}
        disabled={currentPage === 1}
      >
        ⪡
      </button>

      {currentPage > 1 && (
        <button className={style.pageButton} onClick={() => goTo(currentPage - 1)}>
          {currentPage - 1}
        </button>
      )}

      <button className={style.activePage}>{currentPage}</button>

      {currentPage < totalPages && (
        <button className={style.pageButton} onClick={() => goTo(currentPage + 1)}>
          {currentPage + 1}
        </button>
      )}

      <button
        className={style.arrowButton}
        onClick={() => goTo(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        ⪢
      </button>
      <button
        className={style.arrowButton}
        onClick={() => goTo(currentPage + 3)}
        disabled={currentPage > totalPages - 3}
      >
        ⫸
      </button>
    </div>
  );
};

export default Pagination;
